import { useQuery } from "@apollo/client";

import DealsByType from "../DealsByType";
import parseGqlDataByKey from "../parseGqlDataByKey";
import { getTypePageQuery } from "../queries";
import useFeatureState from "./useFeatureState";

export const getDealPageKey = ({ contact_id, current_page, type }) =>
  `expert_${type}_${contact_id}_${current_page}_deals`;

const useDealsByType = ({ contact_id, current_page, type }) => {
  const { buildingId, segmentName } = useFeatureState();

  const dealsKey = getDealPageKey({ contact_id, current_page, type });
  const agentData = parseGqlDataByKey(
    useQuery(getTypePageQuery(dealsKey), {
      variables: {
        deals_type_input: {
          listing_class: type,
          page: current_page,
          per_page: DealsByType.PAGE_SIZE
        },
        expert_id_input: {
          building_id: buildingId,
          contact_id,
          segment_name: segmentName
        }
      }
    })
  );

  return new DealsByType(agentData);
};

export default useDealsByType;
